export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL || 'https://api.bama-food.com/api/v1';

export const MEDIA_BASE_URL =
  process.env.REACT_APP_MEDIA_BASE_URL || 'https://bama-food.sas.amin.parminstorage.ir';

export const getMediaUrl = (path) => {
  if (!path) return '';
  if (/^(https?:\/\/|data:|blob:)/i.test(path)) return path;
  return `${MEDIA_BASE_URL.replace(/\/$/, '')}/${String(path).replace(/^\//, '')}`;
};
